<template>

	<v-card>
		<v-card-title class="headline">Factura de compra</v-card-title>

		<v-card-text>

			<v-menu
				ref="menuFechaFactura"
				v-model="diálogoFechaDeEmisión"
				:close-on-content-click="false"
				transition="scale-transition"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="datos.fechaDeEmisión"
						label="Fecha de emisión de la factura por parte del tercero (Opcional)"
						hint="* Si deja este campo en blanco se asumirá la fecha actual"
						persistent-hint
						readonly
						v-bind="attrs"
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker
					v-model="datos.fechaDeEmisión"
					@input="diálogoFechaDeEmisión = false"
					:first-day-of-week="1"
					show-adjacent-months
					:max="hoy"
					scrollable
				>
				</v-date-picker>
			</v-menu>

			<br>
			<productos-factura-compra ref="productos"></productos-factura-compra>

		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn
				color="grey darken-1"
				text
				:disabled="fuente.guardando"
				@click="cancelar"
			>
				Cancelar
			</v-btn>

			<v-btn
				color="green darken-1"
				text
				:loading="fuente.guardando"
				@click="guardar"
			>
				Guardar
			</v-btn>
		</v-card-actions>
	</v-card>

</template>

<script>
import { facturasDeCompra, productos } from '@/../../cliente_comun/fuentes'
import productosFacturaDeCompra from '@/components/productosFacturaDeCompra.vue'

export default {
	name: 'factura-compra-crear',
  data: () => ({
		fuente: facturasDeCompra,
		fuenteProductos: productos,
		diálogoFechaDeEmisión: false,
		datos: {
			fechaDeEmisión: null
		},
		hoy: new Date().toISOString().substr(0, 10),
	}),
	components: {
		'productos-factura-compra': productosFacturaDeCompra
	},
	mounted: function() {
		this.fuenteProductos.inicializar()
	},
	methods: {
		guardar: function() {
			let confirma = window.confirm('¿Proceder a generar la factura de compra?')
			if (confirma) {
				let dts = this.$refs.productos.obtenerDatos()
				let datos = {
					fechaDeEmisión: this.datos.fechaDeEmisión,
					productos: dts.productos,
					total: dts.total
				}
				this.fuente.guardar(datos).then(() => {
					this.limpiar()
					this.$emit('guardar', true)
				}).catch(() => { })
			}
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar', true)
		},
		limpiar: function() {
			this.$refs.productos.limpiar()
			this.diálogoFechaDeEmisión = false
			this.datos.fechaDeEmisión = null
		}
	}
}
</script>